import { isCmoeProjectionsEnabled } from "../../config/cmoeFeatureFlags";
import { buildActiveHoldsProjection } from "../../domain/cmoe/allocation/allocationLedger";
import {
  matchSummaryToListEntry,
  upsertMatchListEntry,
  removeMatchFromList,
} from "../../domain/cmoe/projection/projectionLogic";

/**
 * Synchronous projection updates (CMOE-ADR-012).
 * @param {import('../../repositories/cmoe/projectionRepository.interface').ProjectionRepository} projectionRepo
 * @param {string} competitionId
 * @param {import('../../domain/cmoe/match/matchTypes').MatchSummary} summary
 */
export async function applyMatchSummaryToProjections(projectionRepo, competitionId, summary) {
  if (!isCmoeProjectionsEnabled()) return;
  const nowMs = Date.now();
  const current = await projectionRepo.getMatchList(competitionId);
  const entry = matchSummaryToListEntry(summary);
  const next = upsertMatchListEntry(
    current ? { ...current, competitionId } : null,
    entry,
    nowMs
  );
  next.competitionId = competitionId;
  await projectionRepo.saveMatchList(competitionId, next);
}

/**
 * @param {import('../../repositories/cmoe/projectionRepository.interface').ProjectionRepository} projectionRepo
 * @param {import('../../repositories/cmoe/allocationRepository.interface').AllocationRepository} allocationRepo
 * @param {string} competitionId
 */
export async function refreshActiveHoldsProjection(projectionRepo, allocationRepo, competitionId) {
  if (!isCmoeProjectionsEnabled()) return;
  const holds = await allocationRepo.listActiveHolds(competitionId);
  const maps = buildActiveHoldsProjection(holds);
  await projectionRepo.saveActiveHolds(competitionId, {
    competitionId,
    ...maps,
    updatedAtMs: Date.now(),
  });
}

/**
 * @param {import('../../repositories/cmoe/projectionRepository.interface').ProjectionRepository} projectionRepo
 * @param {string} competitionId
 * @param {string} matchId
 */
export async function removeMatchFromProjections(projectionRepo, competitionId, matchId) {
  if (!isCmoeProjectionsEnabled()) return;
  const current = await projectionRepo.getMatchList(competitionId);
  if (!current) return;
  await projectionRepo.saveMatchList(
    competitionId,
    removeMatchFromList(current, matchId, Date.now())
  );
}
